// Показателите на „Гости" — върху показаните редове.

import { useTranslation } from "react-i18next";

import { fmtEuro } from "../../../../utils/currency";
import { ReportKpiCard } from "../ReportKpiCard";
import type { GuestsSummaryView } from "./guestsMath";

type Props = {
  summary: GuestsSummaryView;
  isNarrow: boolean;
};

export const GuestsKpis = ({ summary, isNarrow }: Props) => {
  const { t } = useTranslation();

  return (
    <div
      className={`grid gap-2.5 ${
        isNarrow ? "grid-cols-2" : "grid-cols-2 lg:grid-cols-5"
      }`}
    >
      <ReportKpiCard
        kicker={t("reportsPage.rvKpiGuestsCount")}
        value={String(summary.guestsCount)}
        sub={t("reportsPage.rvKpiGuestsCountSub")}
        hero
      />
      <ReportKpiCard
        kicker={t("reportsPage.rvKpiReservations")}
        value={String(summary.reservations)}
        sub={t("reportsPage.rvKpiReservationsOfGuestsSub")}
      />
      <ReportKpiCard
        kicker={t("reportsPage.rvKpiReturning")}
        value={String(summary.returningGuests)}
        sub={t("reportsPage.rvKpiReturningSub")}
      />
      <ReportKpiCard
        kicker={t("reportsPage.rvKpiWithNoShow")}
        value={String(summary.guestsWithNoShow)}
        sub={t("reportsPage.rvKpiWithNoShowSub")}
        hot={summary.guestsWithNoShow > 0}
      />
      <ReportKpiCard
        kicker={t("reportsPage.rvKpiRevenue")}
        value={fmtEuro(summary.revenue)}
        sub={t("reportsPage.rvKpiRevenueSub")}
      />
    </div>
  );
};
